const env = (typeof import.meta !== 'undefined' && import.meta?.env) || {};

window.__SNAP_ENV__ = window.__SNAP_ENV__ || {};
Object.keys(env).forEach((key) => {
  window.__SNAP_ENV__[key] = env[key];
});
window.process = window.process || { env: {} };
window.process.env = window.process.env || {};
window.process.env.NODE_ENV = env.MODE || env.NODE_ENV || 'development';

Object.keys(env).forEach((key) => {
  window.process.env[key] = env[key];
});

if (!window.process.cwd) {
  window.process.cwd = () => '';
}

if (!window.global) {
  window.global = window;
}

